import {
  IconFillToken,
  IconOpacityToken,
  IconSizeToken,
  getIconFillTokenValue,
  getIconOpacityTokenValue,
  getIconSizeTokenValue
} from "../base/icons";

export type IconStateToken =
  | "icon.state.default"
  | "icon.state.hover"
  | "icon.state.active"
  | "icon.state.disabled";

const iconStateDefinitions: Record<IconStateToken, { fill: IconFillToken; opacity?: IconOpacityToken }> = {
  "icon.state.default": { fill: "icon.fill.outlined" },
  "icon.state.hover": { fill: "icon.fill.outlined" },
  "icon.state.active": { fill: "icon.fill.filled" },
  "icon.state.disabled": { fill: "icon.fill.outlined", opacity: "icon.opacity.disabled" }
};

export const ICON_STATE_TOKENS: IconStateToken[] = [
  "icon.state.default",
  "icon.state.hover",
  "icon.state.active",
  "icon.state.disabled"
];

export type ResolvedIconStateToken = {
  fill: number;
  opacity: number;
};

export const resolveIconStateToken = (token: IconStateToken): ResolvedIconStateToken => {
  const definition = iconStateDefinitions[token];
  return {
    fill: getIconFillTokenValue(definition.fill),
    opacity: definition.opacity ? getIconOpacityTokenValue(definition.opacity) : 1
  };
};

export type IconUsageToken =
  | "icon.usage.secondary-action"
  | "icon.usage.listing"
  | "icon.usage.button"
  | "icon.usage.card"
  | "icon.usage.kpi"
  | "icon.usage.kpi-emphasis";

const iconUsageDefinitions: Record<IconUsageToken, IconSizeToken> = {
  "icon.usage.secondary-action": "icon.size.xs",
  "icon.usage.listing": "icon.size.sm",
  "icon.usage.button": "icon.size.md",
  "icon.usage.card": "icon.size.md",
  "icon.usage.kpi": "icon.size.lg",
  "icon.usage.kpi-emphasis": "icon.size.xl"
};

export const ICON_USAGE_TOKENS: IconUsageToken[] = [
  "icon.usage.secondary-action",
  "icon.usage.listing",
  "icon.usage.button",
  "icon.usage.card",
  "icon.usage.kpi",
  "icon.usage.kpi-emphasis"
];

export type ResolvedIconUsageToken = {
  fontSize: string;
  opticalSize: number;
};

const resolveOpticalSize = (fontSize: string): number => {
  const parsed = parseInt(fontSize, 10);
  if (Number.isNaN(parsed)) return 24;
  const clamped = Math.max(20, Math.min(48, parsed));
  return clamped;
};

export const resolveIconUsageToken = (token: IconUsageToken): ResolvedIconUsageToken => {
  const sizeToken = iconUsageDefinitions[token];
  const fontSize = getIconSizeTokenValue(sizeToken);
  return {
    fontSize,
    opticalSize: resolveOpticalSize(fontSize)
  };
};
